import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const DeathTimeDonut = () => {
    const { chartData } = useResultsChartsDataContext();

    return (
        <Donut
            title={'Horário de Nascimento'}
            subtitles={chartData?.deathTime?.map((item) => item.description)}
            chartData={chartData?.deathTime || []}
            colors={defaultColors.slice(0, chartData?.deathTime?.length) || []}
            height={400}
        />
    );
};
